import store from '../../pages/main/store'

const getUser = () => store.getters.getUser

export function formatAmount (value) {
  if (value) {
    return Math.floor(value * 1000) / 1000
  } else {
    return value
  }
}

export function formatRegradingDiffForTool (regradingRecord, toolRecord) {
  const inverted = toolRecord.id == regradingRecord.toolBRecordId
  return formatRegradingDiff(regradingRecord.amountDiff, regradingRecord.amountDiffType, inverted)
}

export function formatRegradingTypeForTool (regradingRecord, toolRecord) {
  const inverted = toolRecord.id == regradingRecord.toolBRecordId
  let regradingTypeId = regradingRecord.regradingType && regradingRecord.regradingType.id
  regradingTypeId = inverted ? invertRegradingType(regradingTypeId) : regradingTypeId
  return mapRegradingTypeToDescription(regradingTypeId)
}

function invertRegradingType (typeId) {
  if (!typeId) {
    return typeId
  }
  if (typeId.endsWith('A')) {
    return typeId.replace(/A$/, 'B')
  }
  if (typeId.endsWith('B')) {
    return typeId.replace(/B$/, 'A')
  }
  return typeId
}

function mapRegradingTypeToDescription (typeIdFromA) {
  switch (typeIdFromA) {
    case 'debitB':
      return 'списания другой позиции'
    case 'creditA':
      return 'приходования данной позиции вместо'
    case 'debitA':
      return 'списания данной позиции вместо'
    case 'creditB':
      return 'приходования другой позиции'
    default:
      return 'Неизвестная причина'
  }
}
export function formatFieldDiffAmount (record) {
  return formatDiff(record.amountDiff, record.amountDiffType)
}

export const amountDiffTypes = [
  { id: 'shortfall', name: 'Недостача' },
  { id: 'surplus', name: 'Излишек' }
]

export const regradingTypes = [
  { id: 'debitB', name: 'Списание вместо позиции А позиции B', amountDiffType: 'shortfall' },
  { id: 'creditA', name: 'Приходование позиции А вместо позиции B', amountDiffType: 'shortfall' },
  { id: 'debitA', name: 'Списание позиции А вместо позиции B', amountDiffType: 'surplus' },
  { id: 'creditB', name: 'Приходование вместо позиции А позиции B', amountDiffType: 'surplus' }
]

export const units = [
  'шт',
  'упак',
  'пар',
  'компл',
  'м',
  'кг',
  'бут',
  'лист',
  'л',
  'м2',
  'м3',
  'рул',
  'мешок',
  'т',
  'гКал'
]

export function getValueFieldAmountDiffRegrading (toolRecord, regradingRecords) {
  let amountRegrading = 0
  if (!toolRecord || toolRecord.amountDiff == null) {
    return
  }
  const rowRegradingRecords = getToolRegradingRecords(toolRecord, regradingRecords)
  if (!rowRegradingRecords || rowRegradingRecords.length === 0) {
    return ''
  }

  let regradingTypeId = null
  amountRegrading = rowRegradingRecords.reduce((sum, regradingRecord) => {
    let regradingAmountDiff = Math.abs(regradingRecord.amountDiff || 0)
    regradingTypeId = regradingRecord.regradingType && regradingRecord.regradingType.id
    if (!regradingTypeId) {
      return
    }
    if (regradingTypeId === 'debitB') {
      // regradingAmountDiff = regradingAmountDiff
    } else if (regradingTypeId === 'creditA') {
      // regradingAmountDiff = regradingAmountDiff
    } else if (regradingTypeId === 'debitA') {
      regradingAmountDiff = -regradingAmountDiff
    } else if (regradingTypeId === 'creditB') {
      regradingAmountDiff = -regradingAmountDiff
    }

    if (toolRecord.id === regradingRecord.toolARecordId) {
      // regradingAmountDiff = regradingAmountDiff
    } else if (toolRecord.id === regradingRecord.toolBRecordId) {
      regradingAmountDiff = -regradingAmountDiff
    }

    return sum + regradingAmountDiff
  }, 0)

  if (!regradingTypeId) {
    return 'Не указана причина пересортицы'
  }

  const amountDiffRegrading = Math.round((toolRecord.amountDiff + amountRegrading) * 10000.0) / 10000.0

  return amountDiffRegrading
}

export function formatFieldAmountDiffRegrading (toolRecord, regradingRecords) {
  const amountDiffRegrading = getValueFieldAmountDiffRegrading(toolRecord, regradingRecords)
  let amountDiffType
  if (amountDiffRegrading > 0) {
    amountDiffType = { id: 'surplus', name: 'Излишек' }
  } else if (amountDiffRegrading < 0) {
    amountDiffType = { id: 'shortfall', name: 'Недостача' }
  } else {
    return amountDiffRegrading
  }

  return formatDiff(amountDiffRegrading, amountDiffType)
}

function formatDiff (diff, amountDiffType) {
  if (amountDiffType && diff != null) {
    return (diff > 0 ? '+' : '') + diff + ` (${amountDiffType.name.toLowerCase()})`
  }
  return 0
}

function formatRegradingDiff (diff, amountDiffType, inverted) {
  if (amountDiffType && diff != null) {
    if (inverted) {
      diff = -diff
      amountDiffType = amountDiffType.id === 'surplus' ? { id: 'shortfall', name: 'Недостача' } : { id: 'surplus', name: 'Излишек' }
    }
    return formatDiff(diff, amountDiffType)
  }
  return null
}

export function getToolRegradingRecords (toolRecord, regradingRecords) {
  return regradingRecords && regradingRecords.filter(r => r.toolARecordId === toolRecord.id || r.toolBRecordId === toolRecord.id) || []
}

export function onInputAmountReal (value, record) {
  if (value === '' || value < 0) {
    value = null
  } else if (value != null) {
    value = Number(value)
  }
  record.amountReal = value

  let amountDiff = null
  if (record.amountRecorded != null && record.amountReal != null) {
    amountDiff = Math.round((record.amountReal - record.amountRecorded) * 10000.0) / 10000.0
  }
  record.amountDiff = amountDiff

  let amountDiffType = null
  if (amountDiff != null) {
    if (amountDiff > 0) {
      amountDiffType = { id: 'surplus', name: 'Излишек' }
    } else if (amountDiff < 0) {
      amountDiffType = { id: 'shortfall', name: 'Недостача' }
    }
  }
  record.amountDiffType = amountDiffType
  record.changeTime = Date.now()

  this.$set(record, 'edited', true)
}

export function deleteConnectedRegradingRecordsWithThis (toolRecord, regradingRecords) {
  const indexRegrading = regradingRecords.findIndex(r => r.toolARecordId === toolRecord.id || r.toolBRecordId === toolRecord.id)
  if (indexRegrading !== -1) {
    if (regradingRecords[indexRegrading].added) {
      regradingRecords.splice(indexRegrading, 1)
    } else {
      this.$set(regradingRecords[indexRegrading], 'removed', true)
    }
  }
}

export function onWithdrawWithThis (toolRecord, filteredRegradingRecords) {
  const withdraw = () => {
    if (toolRecord.withdrawTime) {
      toolRecord.withdrawTime = null
      toolRecord.withdrawUser = null
    } else {
      toolRecord.withdrawTime = Date.now()
      const user = getUser()
      toolRecord.withdrawUser = user.name
    }

    toolRecord.edited = true
  }

  const regrading = getToolRegradingRecords(toolRecord, filteredRegradingRecords).length > 0
  if (regrading) {
    this.$d_ask({
      callback: (data, action) => {
        if (action === 'yes') {
          deleteConnectedRegradingRecordsWithThis.call(this, toolRecord, filteredRegradingRecords)
          withdraw(toolRecord)
        }
      },
      buttons: {
        yes: 'Да',
        close: 'Отмена'
      },
      header: 'Записи пересортицы с данной позицией будут удалены. Продолжить?'
    })
  } else {
    withdraw(toolRecord)
  }
}

const SURPLUS_TRANSFER_STATE_LIST = [{
  key: 'confirmed',
  name: 'Сдача излишков подтверждена',
  priority: 3,
  color: 'green'
}, {
  key: 'notConfirmed',
  name: 'Сдача излишков не подтверждена',
  priority: 2,
  color: 'warning',
  cssColor: '#F2C037'
}, {
  key: 'notTransferred',
  name: 'Излишки не сданы на склад',
  priority: 1,
  color: 'red'
},
{
  key: 'absent',
  name: 'Излишки отсутствуют',
  priority: 4,
  color: 'white'
}, {
  key: 'empty',
  name: '',
  priority: 5,
  color: 'white'
}]
SURPLUS_TRANSFER_STATE_LIST.forEach(state => {
  if (!state.cssColor) {
    state.cssColor = state.color
  }
})
const SURPLUS_TRANSFER_STATE = Object.fromEntries(SURPLUS_TRANSFER_STATE_LIST.map(state => [state.key, state]))

export function getToolRecordSurplusState (toolRecord, toolRecordsPropertyConfig, surplusTransferFilesGroup = null) {
  const surplusTransferAvailable = toolRecordsPropertyConfig && toolRecordsPropertyConfig.accessProps && toolRecordsPropertyConfig.accessProps.surplusTransferAvailable
  const surplusDetected = toolRecord.amountDiffType && toolRecord.amountDiffType.id === 'surplus'
  const hasSurplusTransferPhotos = surplusTransferFilesGroup ? surplusTransferFilesGroup.hasFiles() : toolRecord.surplusTransferPhotos && toolRecord.surplusTransferPhotos.length > 0
  const surplusTransferred = !!toolRecord.surplusTransferTime && hasSurplusTransferPhotos
  const surplusTransferRequired = surplusTransferAvailable && surplusDetected && !surplusTransferred
  const surplusTransferConfirmed = !!toolRecord.surplusTransferConfirmationTime
  const surplusTransferConfirmationRequired = surplusTransferred && !surplusTransferConfirmed

  let surplusState
  if (surplusTransferConfirmed) {
    surplusState = SURPLUS_TRANSFER_STATE.confirmed
  } else if (surplusTransferConfirmationRequired) {
    surplusState = SURPLUS_TRANSFER_STATE.notConfirmed
  } else if (surplusTransferRequired) {
    surplusState = SURPLUS_TRANSFER_STATE.notTransferred
  } else if (!surplusDetected) {
    surplusState = SURPLUS_TRANSFER_STATE.absent
  } else {
    surplusState = SURPLUS_TRANSFER_STATE.empty
  }

  return { state: surplusState, surplusDetected, surplusTransferred, surplusTransferRequired, surplusTransferConfirmed, surplusTransferConfirmationRequired }
}

export function getSurplusStateColor (surplusState) {
  const stateConfig = getSurplusStateConfig(surplusState)
  return stateConfig && stateConfig.color || 'white'
}

export function getSurplusStateConfig (surplusState) {
  const key = surplusState && (surplusState.key || surplusState.id) || null
  return key && SURPLUS_TRANSFER_STATE[key] || null
}

export function getMainSurplusState (toolRecords, toolRecordsPropertyConfig) {
  if (!toolRecords || !toolRecords.length) {
    return SURPLUS_TRANSFER_STATE.absent
  }
  const states = toolRecords.map(toolRecord => getToolRecordSurplusState(toolRecord, toolRecordsPropertyConfig))
  const sorted = states.sort((a, b) => a.state.priority - b.state.priority)
  return sorted[0].state
}

export function formatUniqueToolName (tool) {
  const uniqueParts = []

  if (tool.partyName) {
    uniqueParts.push(`парт.: ${tool.partyName}`)
  }
  if (tool.serialNumber) {
    uniqueParts.push(`с.н.: ${tool.serialNumber}`)
  }
  if (tool.inventoryNumber) {
    uniqueParts.push(`инв.н.: ${tool.inventoryNumber}`)
  }

  const uniqueText = uniqueParts.length ? ` (${uniqueParts.join(', ')})` : ''
  return `${tool.name}${uniqueText}`
}
